import { StrictMode } from 'react';
import * as Sentry from "@sentry/react";
import { createRoot } from 'react-dom/client';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { Suspense, ReactNode } from 'react';
import './index.css';

import Home from './pages/home/page.tsx';
import Posts from './pages/posts/page.tsx';
import Post from './pages/post/page.tsx';
import { Navigate } from 'react-router-dom';

Sentry.init({
  dsn: "https://6ba9463f00610ab1f25a1e65f6c59e6a@o4509249058635781.ingest.us.sentry.io/4509282494644224",
  sendDefaultPii: true,
  integrations: [
    Sentry.replayIntegration()
  ],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

interface LayoutProps {
  children: ReactNode;
}

function Layout({ children }: LayoutProps) {
  return (
    <div>
      <div className="min-h-screen transition-all bg-neutral-950 duration-200 ease-in-out">
        {children}
      </div>
    </div>
  );
}

function App() {
  const location = useLocation();

  return (
    <Layout>
      <Suspense>
        <AnimatePresence mode="wait">
          <motion.div
            key={location.pathname}
            initial="initial"
            animate="animate"
            exit="exit"
            className="h-full"
          >
            <Routes location={location}>
              <Route path="/" element={<Home />} />
              <Route path="/posts" element={<Posts />} />
              <Route path="/posts/:postId" element={<Post />} />
              <Route path="*" element={<Navigate to="/" />} />
            </Routes>
          </motion.div>
        </AnimatePresence>
      </Suspense>
    </Layout>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
);
